import { ShakoKeiyakushaToShiyoushaKbn } from "~/extensions/utils/DefineTypes";
export class ShomeiEntry {
    shomeiNo = 0;
    soufuName = "";
    postcode = "";
    adr1 = "";
    adr2 = "";
    adr3 = "";
    addressAll = "";
    tel = "";
    email = "";
    shomeiKbnList = [];
    shomeiKb = 0;
    shomeiKbName = "";
    selectedShomeiKbn = null;
    tesuryo = "";
    isShakoShomei = false;
    shakoChushamei = "";
    shakoKukaku = "";
    shinseishaKb = 1;
    shinseishaName = "";
    shinseishaPostcode = "";
    shinseishaAdr1 = "";
    shinseishaAdr2 = "";
    shinseishaAdr3 = "";
    shinseishaTel = "";
    fromEntry = false;
    shomeiStatusName = "";
    shinseiYmd = new Date();
    shomeiBikou = "";
    shosikiSiteiKb = 0;
    isKyojuShomei = false;
    shogakukinKb = 1;
    rentStartDate = "";
    rentEndDate = "";
    isRentShomei = false;
    orgNyukyokeiyakuNo = 0;
    userName = "";
    postCodeKeiyaku = "";
    adr1Keiyaku = "";
    adr2Keiyaku = "";
    bukenName = "";
    roomNo = "";
    tuisekiNo = "";
    file = null;
    get usedByShiyousha() {
        return this.shinseishaKb === ShakoKeiyakushaToShiyoushaKbn.different;
    }
}
